import { render } from "./BillingCategory.vue?vue&type=template&id=edafa166"
import script from "./BillingCategory.vue?vue&type=script&lang=js"
export * from "./BillingCategory.vue?vue&type=script&lang=js"

import "./BillingCategory.vue?vue&type=style&index=0&id=edafa166&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/BillingCategory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "edafa166"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('edafa166', __exports__)) {
    console.log('reload')
    api.reload('edafa166', __exports__)
  }
  
  module.hot.accept("./BillingCategory.vue?vue&type=template&id=edafa166", () => {
    console.log('re-render')
    api.rerender('edafa166', render)
  })

}


export default __exports__